import React from 'react';
import cover from './assets/png/banner-web-iq4.png';
import micitt from './assets/png/micitt.png';
import iq4 from './assets/svg/iQ4-logo-2.svg';
import iq4White from './assets/svg/iQ4-logo.svg';
import facebook from './assets/svg/facebook.svg';
import twitter from './assets/svg/twitter.svg';
import linkedin from './assets/svg/linkedin.svg';
import cwa from './assets/png/CWA-long.png';
import cwaWhite from './assets/png/CWA-white.png';
import techruptive from './assets/png/techruptive-logo_color.png';
import programas from './assets/png/background-programas.png';
import quotes from './assets/png/background-quotes.png';
import triangles from './assets/png/triangles.png';
import trianglesRight from './assets/png/right-triangle-benefits.png';
import trianglesSobre from './assets/png/triangles-sobre.png';
import trianglesNuestros from './assets/png/Triangle-nuestros.png';
import trianglesProgramas from './assets/png/triangles-programas.png';
import firstTriangles from './assets/png/first-triangles.png';
import comptialogo from './assets/png/CompTIASecurity.png';
import comptiaPenTestlogo from './assets/png/compTIAPenTest.png';

import cloud from './assets/png/cloud-logo.png';
import pentest from './assets/png/Pentest-logo.png';
import forensic from './assets/png/forensicsAnalysis-logo.png';
import csx from './assets/png/CSX-logo.png';

import './App.scss';

const cloudPdf = process.env.PUBLIC_URL + '/docs/Cloud_Fundamentals.pdf';
const cyberPdf = process.env.PUBLIC_URL + '/docs/Cyber_Security_Pack.pdf';
const cyberGirlPdf = process.env.PUBLIC_URL + '/docs/Cyber_Security_Pack_Girl_Power_Edition.pdf';
const ethicalHackingPdf = process.env.PUBLIC_URL + '/docs/Ethical_Hacking_Pack.pdf';
const pentestPdf = process.env.PUBLIC_URL + '/docs/PenTest_&_Forensic_Analysis_Pack.pdf';
const convocatoria = process.env.PUBLIC_URL + '/docs/Segunda_Convocatoria_IQ4.pdf';

const anexo1 = process.env.PUBLIC_URL + '/docs/Anexo_1_Hoja_de_vida.docx';
const anexo2 = process.env.PUBLIC_URL + '/docs/Anexo_2_Declaracion_Jurada.docx';
const anexo3 = process.env.PUBLIC_URL + '/docs/Anexo_3_Consentimiento_informado.docx';

const bg = {
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundImage: `url(${cover})`,
};

const bg2 = {
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundImage: `url(${programas})`,
};

const bg3 = {
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundImage: `url(${quotes})`,
};

function App() {

  const TestimonialItem = ({ children, showLine }) => (
    <>
      {children}
      {showLine && <div className="requisitos-line" />}
    </>
  )

  return (
    <div>
      <div className="header-container">
        <div className="fixed-header">
          <img src={iq4White} className="fixed-header--icon" />
          <img src={micitt} className="fixed-header--micitt" />
          <img src={cwaWhite} className="fixed-header--cwa" />
          <img src={techruptive} className="fixed-header--techruptive" />
        </div>
      </div>
      <div className="section-with-background" style={bg}>
        <img className="first-triangles" src={firstTriangles} alt="" />
        <div className="content-container">
          <div className="main-title">Descubre becas completas en cursos de ciberseguridad</div>
          <div className="white-label">MICITT pone a tu disposición las becas a través</div>
          <div className="white-label">de la colaboración con iQ4</div>
          <div className="white-label-description">
            <span className="white-label-description--strong">¡Transforma tu carrera en Ciberseguridad! </span>
            <span>Ponemos a tu disposición becas <span className="white-label-description--blue">gratuitas </span>
            de capacitación PINN para acceder a un mercado laboral atractivo rápido en una modalidad 100% online con clases en vivo.</span>
          </div>
        </div>
      </div>
      <div className="sobre">
        <div className="sobre-white-cover" />
        <div className="content-container">
          <div className="sobre-container">
            <img className="sobre-logo" src={micitt} alt="micitt Logo" />
            <div className="sobre-description">
              <div className="sobre-description--title">
                Sobre nosotros
              </div>
              <div className="sobre-description--main">
                El Ministerio de Ciencia, Tecnología y Telecomunicaciones de Costa Rica (MICITT), con el apoyo del Banco Interamericano de Desarrollo (BID), pone a disposición de los costarricenses el Programa de Innovación y Capital Humano (PINN), el cual consta de becas para costarricenses que deseen capacitarse en áreas tecnológicas.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-with-background" style={bg2}>
        <img className="programas-triangles" src={trianglesProgramas} alt="" />
        <div className="programas-white-cover" />
        <div className="content-container">
          <div className="programas-blue">Capacitación laboral</div>
          <div className="programas-title">Programas</div>
          <div className="programas-content-container">
            <div className="programas-item">
              <div className="programas-item--title">100% gratuitos</div>
              <div className="programas-item--line" />
              <div className="programas-item--content">Contribuimos con el crecimiento de la productividad y con la mejora de la empleabilidad en los sectores de ciberseguridad</div>
            </div>
            <div className="programas-item">
              <div className="programas-item--title">Programas online</div>
              <div className="programas-item--line" />
              <div className="programas-item--content">Oportunidad de desarrollar competencias internacionales online con mentores especialistas en la materia, reconocidos por el sector empresarial, con una enseñanza dedicada y atención personalizada</div>
            </div>
            <div className="programas-item">
              <div className="programas-item--title">Ámbito laboral</div>
              <div className="programas-item--line" />
              <div className="programas-item--content">Facilidad para ser contratado por empresas, maximizar la productividad en la oficina y elevar la eficiencia de la organización, y la colaboración con otros profesionales.</div>
            </div>
          </div>
          <div className="programas-btn-container">
            <a target="_blank" rel="noreferrer" href="http://eepurl.com/htFDhX" className="programas-btn">
              Regístrate
            </a>
          </div>
        </div>
      </div>
      <div className="nuestros-programas">
        <img className="nuestros-triangles" src={trianglesNuestros} alt="" />
        <div className="content-container">
          <div className="nuestros-programas-small-title">Certificaciones</div>
          <div className="nuestros-programas-title">Nuestros Programas</div>
          <div className="nuestros-programas-description-container">
            <div className="nuestros-programas-description-container--bold-text">Programa Intensivo</div>
            <div className="nuestros-programas-description-container--text">Modalidad tiempo parcial y online. Aprovecha tu tiempo y en 4 ó 7 semanas y comienza una carrera en cyberseguridad.<br /> Son 32 ó 56 horas de clases en vivo, con mentores expertos en la materia que te ayudarán a desarrollarte profesionalmente.</div>
          </div>
          <div className="nuestros-programas-content-container">
            <div className="nuestros-programas-item" style={{ backgroundColor: 'rgba(78, 224, 234, 0.73)' }}>
              <div className="nuestros-programas-item--top" style={{ backgroundColor: 'rgba(255, 254, 254, 0.31)' }}>56 horas</div>
              <div className="nuestros-programas-item--title">Cyber Security Pack</div>
              <div className="nuestros-programas-item--content">7 semanas</div>
              <div className="nuestros-programas-item--bold">USD$ 3.634,00</div>
              <div className="nuestros-programas-btn-container">
                <a href={cyberPdf} target="_blank" rel="noreferrer" className="nuestros-programas-item--button">Ver información para obtener la certificatión</a>
              </div>
              <div className="nuestros-programas-item--footer"><img src={comptialogo} style={{ height: 70 }} /></div>
            </div>
            <div className="nuestros-programas-item" style={{ backgroundColor: 'rgba(201, 41, 153, 0.73)' }}>
              <div className="nuestros-programas-item--top" style={{ backgroundColor: 'rgba(255, 254, 254, 0.31)' }}>56 horas</div>
              <div className="nuestros-programas-item--title">Cyber Security Pack: Girl Power Edition</div>
              <div className="nuestros-programas-item--content">7 semanas</div>
              <div className="nuestros-programas-item--bold">USD$ 3.634,00</div>
              <div className="nuestros-programas-btn-container">
                <a href={cyberGirlPdf} target="_blank" rel="noreferrer" className="nuestros-programas-item--button">Ver información para obtener la certificatión</a>
              </div>
              <div className="nuestros-programas-item--footer"><img src={comptialogo} style={{ height: 70 }} /></div>
            </div>
            <div className="nuestros-programas-item" style={{ backgroundColor: 'rgba(255, 255, 179, 1)' }}>
              <div className="nuestros-programas-item--top" style={{ backgroundColor: 'rgba(24, 27, 150, 0.31)' }}>56 horas</div>
              <div className="nuestros-programas-item--title">Ethical Hacking Pack</div>
              <div className="nuestros-programas-item--content">7 semanas</div>
              <div className="nuestros-programas-item--bold">USD$ 4.476</div>
              <div className="nuestros-programas-btn-container">
                <a href={ethicalHackingPdf} target="_blank" rel="noreferrer" className="nuestros-programas-item--button">Ver información para obtener la certificatió</a>
              </div>
              <div className="nuestros-programas-item--footer"><img src={comptiaPenTestlogo} style={{ height: 70 }} /></div>
            </div>
          </div>
          <div className="programas-btn-container">
            <a target="_blank" rel="noreferrer" href="http://eepurl.com/htFDhX" className="programas-btn">
              Regístrate
            </a>
          </div>
        </div>
      </div>
      <div className="section-with-background" style={bg2}>
        <img className="sobre-triangles" src={trianglesSobre} alt="" />
        <div className="content-container">
          <div className="programas-blue">Testimonios</div>
          <div className="programas-title">Sobre iQ4</div>
          <div className="programas-content-container">
            <div className="testimonios-item">
              <div className="testimonios-item--content">
                <div className="testimonios-item--testimonio">
                  "Cada mentor brindó no solo información sobre el material en el que trabajaban los estudiantes, sino también una mejor comprensión general de los problemas  reales que ellos mismos enfrentan  en la industria". -
                </div>
                <div className="testimonios-item--autor-container">
                  <div className="testimonios-item--autor">Brian Hillegas</div>
                  <div className="testimonios-item--autor">Director of Threat Intelligence</div>
                </div>
              </div>
            </div>
            <div className="testimonios-item">
              <div className="testimonios-item--content">
                <div className="testimonios-item--testimonio">
                  iQ4 me empoderó como mujer en tecnología y estudiantes universitarias de primera generación con el conocimiento, los recursos y la red necesarios para navegar en la industria de la ciberseguridad". -
                </div>
                <div className="testimonios-item--autor-container">
                  <div className="testimonios-item--autor">Soraya de John Jay</div>
                  <div className="testimonios-item--autor">College</div>
                </div>
              </div>
            </div>
            <div className="testimonios-item">
              <div className="testimonios-item--content">
                <div className="testimonios-item--testimonio">
                  Entre mi título, el programa CWA y la posterior pasantía en el Banco de la Reserva Federal de Nueva York, estoy bien posicionado para comenzar una carrera en riesgos de TI". -
                </div>
                <div className="testimonios-item--autor-container">
                  <div className="testimonios-item--autor">Allison de la Universidad</div>
                  <div className="testimonios-item--autor">de Albany</div>
                </div>
              </div>
            </div>
          </div>
          <div className="programas-btn-container">
            <a target="_blank" rel="noreferrer" href="http://eepurl.com/htFDhX" className="programas-btn">
              Regístrate
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="content-container">
          <div className="requisitos-white-cover" />
          <div className="requisitos-perguntas">Tienes preguntas?</div>
          <div className="requisitos-title">Requisitos</div>
          <div className="requisitos-container">
            <div className="requisitos-container--requisitos">
              <div className="requisitos-container--title">
                Requisitos de Admisibilidad
              </div>
              <TestimonialItem showLine>
                <div className="requisitos-text">
                  Ser mayor de edad
                </div>
              </TestimonialItem>
              <TestimonialItem showLine>
                <div className="requisitos-text">
                  Costarricense por nacimiento o por naturalización, o extranjeros con residencia permanente en Costa Rica.
                </div>
              </TestimonialItem>
              <TestimonialItem showLine>
                <div className="requisitos-text">
                  Estar domiciliado en el territorio nacional.
                </div>
              </TestimonialItem>
              <TestimonialItem showLine>
                <div className="requisitos-text">
                  Haber concluido y aprobado el cuarto ciclo de la educación diversificada en una institución educativa técnica o académica.
                </div>
                <div className="requisitos-sub-text-1">
                  Se verificará mediante copia del título o mediante certificado de notas.
                </div>
                <div className="requisitos-sub-text-2">
                  Un grado mínimo de bachillerato universitario en áreas fuera de las ciencias exactas, ciencias naturales o ingeniería, Se verificará mediante copia del título o certificado de notas.
                </div>
              </TestimonialItem>
              <TestimonialItem showLine>
                <div className="requisitos-text">
                  Laborar en el sector privado o encontrarse desempleado.
                </div>
                <div className="requisitos-sub-text-1">
                  Este concurso está dirigido exclusivamente a personas que no laboren en el sector público, puesto que su objetivo es mejorar la empleabilidad y competitividad en el sector privado.
                </div>
              </TestimonialItem>
              <TestimonialItem>
                <div className="requisitos-text">
                  Contar con disponibilidad de tiempo necesario para participar en la totalidad de la capacitación y/o certificación.
                </div>
              </TestimonialItem>
            </div>
            <div className="requisitos-right">
              <div className="requisitos-container--requisitos">
                <div className="requisitos-container--title">
                  Requisitos Técnicos
                </div>
                <TestimonialItem showLine>
                  <div className="requisitos-text">
                    Nivel del inglés B1.
                  </div>
                  <div className="requisitos-sub-text-1">
                    Se verifica mediante la aplicación de una prueba lógica/matemática en inglés una vez se haya verificado el cumplimiento de los requisitos de admisibilidad.
                  </div>
                </TestimonialItem>
                <TestimonialItem showLine>
                  <div className="requisitos-text">
                    Contar con compromiso, motivaciones y disponibilidad para realizar el curso.
                  </div>
                  <div className="requisitos-sub-text-1">
                    Se verifica mediante la aplicación de una entrevista sociolaboral oral y escrita, una vez se haya verificado el cumplimiento de los requisitos de admisibilidad.
                  </div>
                </TestimonialItem>
              </div>
              <div className="black-box">
                <div className="black-box--title">
                  Documentos para registrarse
                </div>
                <ul className="black-box--list">
                  <li>Copia de la cédula de identidad o DIMEX</li>
                  <li>Copia de los títulos de educación formal que haya obtenido (revisar convocatorias)</li>
                  <li>Documentos proporcionados en los 3 Anexos</li>
                </ul>
                <div className="black-box--button-container">
                  <div className="black-box--blue">
                    Revisá las bases y consultá los documentos necesarios que tendrás que presentar
                  </div>
                  <a className="black-box--btn"
                       target="_blank"
                       href={convocatoria}
                  >
                    Ver bases
                  </a>
                </div>
                <div className="black-box--line" />
                <div className="black-box--download-container">
                  <div className="black-box--download-text">Anexo 1: Curriculum Vitae</div>
                  <a href={anexo1} target="_blank" className="black-box--download-btn">Descargar</a>
                </div>
                <div className="black-box--download-container">
                  <div className="black-box--download-text">Anexo 2: Declaración jurada</div>
                  <a href={anexo2} target="_blank" className="black-box--download-btn">Descargar</a>
                </div>
                <div className="black-box--download-container">
                  <div className="black-box--download-text">Anexo 3: Consentimiento informado</div>
                  <a href={anexo3} target="_blank" className="black-box--download-btn">Descargar</a>
                </div>
              </div>
            </div>
          </div>
          <div className="perfiles-container">
            <div className="perfiles-container--requisitos">
              <div className="perfiles-container--title">
                Perfiles
              </div>
              <div className="perfiles-container--perfile">
                <strong>Perfil 1 (técnico):</strong> Personas elegibles que han concluido el cuarto ciclo de educación diversificada en un colegio técnico o que poseen un grado técnico de una institución universitaria o parauniversitaria, relacionado con áreas científico-tecnológicas. Se verificará mediante copia del título o mediante certificado de notas.
              </div>
              <div className="perfiles-container--perfile">
                <strong>Perfil 2 (universitario):</strong> Personas elegibles que cuentan con un mínimo de bachillerato universitario en ciencias exactas, ciencias naturales o ingeniería. Se verificará mediante copia del título.
              </div>
              <div className="perfiles-container--perfile">
                <strong>Perfil 3 (universitario y técnico):</strong> Personas elegibles que han concluido el cuarto ciclo de educación diversificada en un colegio técnico o que poseen un grado técnico de una institución universitaria o parauniversitaria, o un grado mínimo de bachillerato universitario en áreas fuera de las ciencias exactas, ciencias naturales o ingeniería, con el objetivo de recalificar el recurso humano o de brindar herramientas para complementar su área de conocimiento. Se verificará mediante copia del título o mediante certificado de notas.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-with-background" style={bg3}>
        <div className="content-container">
          <img className="postulacion-triangles" src={triangles} alt="" />
          <div className="programas-blue">Sigue estos pasos</div>
          <div className="programas-title">Proceso de postulación</div>
          <div className="postulacion-content-container">
            <div className="postulacion-item">
              <div className="postulacion-item--number">1</div>
              <div className="postulacion-item--content">
                <div className="postulacion-item--title">
                  Completá el formulario de Consentimiento Informado
                </div>
                <div className="postulacion-item--explanation">
                  Una vez completado el formulario de “Consentimiento  Informado” recibirás una confirmación y un link para completar el proceso de registación.
                </div>
              </div>
            </div>
            <div className="postulacion-item">
              <div className="postulacion-item--number">2</div>
              <div className="postulacion-item--content">
                <div className="postulacion-item--title">
                  Proveer toda la documentación solicitada
                </div>
                <div className="postulacion-item--explanation">
                  Recibirás un correo solicitándote los documentos requeridos (Anexos 1, 2 y 3),
                </div>
              </div>
            </div>
            <div className="postulacion-item">
              <div className="postulacion-item--number">3</div>
              <div className="postulacion-item--content">
                <div className="postulacion-item--title">
                  Entrevista técnica
                </div>
                <div className="postulacion-item--explanation">
                  Se le realizará una breve entrevista telefónica de comprobación de su nivel de conocimiento técnico.
                </div>
              </div>
            </div>
            <div className="postulacion-item">
              <div className="postulacion-item--number">4</div>
              <div className="postulacion-item--content">
                <div className="postulacion-item--title">
                  Verificación de CINDE
                </div>
                <div className="postulacion-item--explanation">
                  Recibirás un correo de Cinde notificando si has sido seleccionado.
                </div>
                <div className="postulacion-item--explanation">
                  Los usuarios seleccionaddos deberán firmar el  Contrato de Adjudicación y  enviar toda la  documentación a las oficinas de CINDE
                </div>
              </div>
            </div>
            <div className="postulacion-item">
              <div className="postulacion-item--number">5</div>
              <div className="postulacion-item--content">
                <div className="postulacion-item--title">
                  Empezá  a estudiar
                </div>
                <div className="postulacion-item--explanation">
                  Certificate y pon rumbo a tu carrera en cyberseguridad!
                </div>
              </div>
            </div>
          </div>


          <div className="postulacion-content-container" style={{ justifyContent: 'center' }}>

          </div>

          <div className="programas-btn-container">
            <a target="_blank" href={convocatoria} className="programas-btn programas-btn-container--no-bold">
              Ver bases
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="content-container">
          <div className="requisitos-perguntas">Sobre iQ4</div>
          <div className="requisitos-title">Beneficios</div>
          <img className="beneficios-triangles" src={triangles} alt="" />
          <img className="beneficios-right-triangles" src={trianglesRight} alt="" />
          <div className="beneficios-container">
            <div style={{ width: '100%' }}>
              <div className="beneficios-title">Beneficios del curso</div>
              <div style={{ display: 'flex' }}>
                <div className="beneficios-body">
                  <div className="beneficios-body--item">
                  - Formación técnica en las habilidades y competencias necesarias para trabajos de alta demanda.
                </div>
                  <div className="beneficios-body--item">
                  - Utilización de laboratorios para realizar las prácticas reales
                </div>
                  <div className="beneficios-body--item">
                  - Conocimientos y habilidades adquiridos al trabajar con expertos de la industria (mentores)
                </div>
                  <div className="beneficios-body--item">
                  - Habilidades profesionales mejoradas que incluyen trabajo en equipo, pensamiento crítico, presentación, redacción
                </div>
                </div>
                <div className="beneficios-body" style={{ marginLeft: 60 }}>
                  <div className="beneficios-body--item">
                    - Trayectorias profesionales hacia trabajos de ciberseguridad y tecnología de la información.
                  </div>
                  <div className="beneficios-body--item">
                    - Conocimientos adquiridos para realizar exámenes de certificación profesional.
                  </div>
                  <div className="beneficios-body--item">
                    - Credencial iQ4 reconocida por la industria y certificado que conlleva hasta 250 horas de capacitación en el trabajo.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="beneficios-title">
            iQ4 Industry Recognized Credential
          </div>
          <div className="beneficios-body">
            <div className="beneficios-body--item margin-down">
              Al finalizar su curso exitosamente, se le entregará una Credencial reconocida por la industria que identifica la cantidad de horas de capacitación en el trabajo que ha ganado. La fuente emisora de la credencial reconocida por la industria.es el Cybersecurity Workforce Alliance (CWA)
            </div>
          </div>
          <div className="beneficios-title">
            iQ4 Corporation
          </div>
          <div className="beneficios-body">
            <div className="beneficios-body--item margin-down">
              iQ4 es una empresa de software cuya plataforma virtual de aprendizaje consta de cursos que combinan la formación técnica y el aprendizaje aplicado. Los estudiantes adquieren conocimientos y habilidades a través de nuestra metodología probada de combinar materias técnicas, proyectos del mundo real e integración de mentores, lo que conduce a trayectorias profesionales y trabajos en ciberseguridad y tecnología de la información.
            </div>
          </div>
          <div className="footer">
            <div className="social-media--follow">Follow us <span className="social-media--icon-container">
              <a href="https://www.facebook.com/iQ4Cyber" rel="noreferrer" target="_blank"><img className="social-media--icon" src={facebook} alt="" /></a>
              <a href="https://twitter.com/iQ4Cyber" rel="noreferrer" target="_blank"><img className="social-media--icon" src={twitter} alt="" /></a>
              <a href="https://www.linkedin.com/company/iq4" rel="noreferrer" target="_blank"><img className="social-media--icon" src={linkedin} alt="" /></a>
            </span></div>
            <div className="footer--logo-container">
              <img className="footer--iq4-logo" src={iq4} alt="" />
              <img className="footer--cwa-logo" src={cwa} alt="" />
              <img className="footer--micitt-logo" src={micitt} alt="" />
              <img className="footer--techruptive-logo" src={techruptive} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
